import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "step" }
const _hoisted_2 = { class: "step-header" }
const _hoisted_3 = { class: "step-icon" }
const _hoisted_4 = { class: "upload-wrap" }
const _hoisted_5 = { class: "form-field" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "upload-card" }
const _hoisted_8 = {
  key: 0,
  class: "preview"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_11 = { class: "actions" }
const _hoisted_12 = { class: "file-name" }
const _hoisted_13 = {
  key: 2,
  class: "api-error"
}

import { computed, onBeforeUnmount, ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadLogoStep',
  props: {
    current_step: {},
    errors: {},
    profileInfo: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const logoInput = ref<HTMLInputElement | null>(null);
const logoFile = ref<File | null>(null);
const previewUrl = ref<string | null>(null);
const isBlobPreview = ref(false);

const logoError = ref("");
const existingLogoUrl = computed<string | null>(() => props.profileInfo?.logo?.url || null);
const existingLogoName = computed(() => {
  const url = existingLogoUrl.value || "";
  if (!url) return "";
  const raw = url.split("?")[0];
  const last = raw.split("/").pop() || "";
  return last || "Current logo";
});
const displayFileName = computed(() => {
  if (logoFile.value?.name) return logoFile.value.name;
  if (existingLogoUrl.value) return existingLogoName.value;
  return "No file selected";
});

function getValues() {
  return {
    logoFile: logoFile.value,
    previewUrl: previewUrl.value,
  };
}

__expose({ getValues });

function revokePreview() {
  if (previewUrl.value && isBlobPreview.value) {
    URL.revokeObjectURL(previewUrl.value);
  }
  previewUrl.value = null;
  isBlobPreview.value = false;
}

watch(logoFile, (file) => {
  revokePreview();
  if (file) {
    previewUrl.value = URL.createObjectURL(file);
    isBlobPreview.value = true;
  } else if (existingLogoUrl.value) {
    previewUrl.value = existingLogoUrl.value;
    isBlobPreview.value = false;
  }
});

onBeforeUnmount(() => {
  revokePreview();
});

watch(
  existingLogoUrl,
  (url) => {
    if (!url) return;
    if (logoFile.value) return;
    // Only prefill if user hasn't selected a new logo yet.
    previewUrl.value = url;
    isBlobPreview.value = false;
  },
  { immediate: true },
);

watch(() => props.errors, (errs: any) => {
  logoError.value = "";
  if (!errs) return;
  if (errs.logo) logoError.value = errs.logo;
  if (errs.logoFile) logoError.value = errs.logoFile;
}, { immediate: true });

function pickUpload() {
  logoInput.value?.click();
}

function clearLogo() {
  logoFile.value = null;
  if (logoInput.value) logoInput.value.value = "";
  if (existingLogoUrl.value) {
    previewUrl.value = existingLogoUrl.value;
    isBlobPreview.value = false;
  }
}

function onChange(event: Event) {
  const input = event.target as HTMLInputElement | null;
  const file = input?.files?.[0] || null;
  logoFile.value = file;
  if (input) input.value = "";
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "#e8612f"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("mdi-image-outline", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "step-content" }, [
        _createElementVNode("h2", { class: "title" }, "Add your logo"),
        _createElementVNode("p", { class: "desc" }, " Upload a clear logo to personalize your storefront and branding. ")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_icon, {
            class: "label-icon",
            size: "16",
            color: "#6b7280"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-image-outline", -1)
            ]))]),
            _: 1
          }),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "Business logo", -1))
        ])
      ]),
      _createElementVNode("input", {
        ref_key: "logoInput",
        ref: logoInput,
        type: "file",
        class: "file-input",
        accept: "image/*",
        onChange: onChange
      }, null, 544),
      _createElementVNode("div", _hoisted_7, [
        (previewUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("img", {
                src: previewUrl.value,
                alt: "Logo preview"
              }, null, 8, _hoisted_9)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_v_icon, { size: "22" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-image-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "placeholder-text" }, "No logo selected", -1))
            ])),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_v_btn, {
            variant: "outlined",
            "prepend-icon": "mdi-upload",
            onClick: pickUpload
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(logoFile.value ? "Change logo" : "Select logo"), 1)
            ]),
            _: 1
          }),
          (logoFile.value)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                variant: "text",
                color: "error",
                "prepend-icon": "mdi-delete-outline",
                onClick: clearLogo
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" Remove ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, _toDisplayString(displayFileName.value), 1),
        (logoError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(logoError.value), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})